/**
 * 全局 loading 策略（与 $loadingDiv1、ElLoading.service 共用）
 * 只改下面这一个对象即可，无需 process.env、无需每个请求传 silent。
 *
 * - disableAll: true 时任何机构都不显示 loading
 * - onlyForInstitutions: 非空时仅这些 institution 显示 loading（与登录 sessionStorage.institution 一致）
 * - hideForInstitutions: 黑名单；仅当 onlyForInstitutions 为空时生效（须与 sessionStorage.institution **逐字相同**）
 *
 * 单次强制显示：调用时传 forceLoading: true
 */
export const APP_LOADING_POLICY = {
  disableAll: false,
  onlyForInstitutions: [],
  hideForInstitutions: ['小熊备考'],
}

/** 是否应该抑制 loading */
export function shouldSuppressAppLoading(options = {}) {
  if (options.forceLoading === true) return false

  if (options.silent === true || options.showLoading === false) return true

  if (APP_LOADING_POLICY.disableAll) return true

  if (typeof sessionStorage === 'undefined') return false

  const inst = (sessionStorage.getItem('institution') || '').trim()
  if (!inst) return false

  const only = APP_LOADING_POLICY.onlyForInstitutions || []
  if (only.length) {
    return !only.includes(inst)
  }

  const hide = APP_LOADING_POLICY.hideForInstitutions || []
  return hide.includes(inst)
}

/** Element Plus 返回体至少要有 close；部分版本会调 setText */
export function noopLoadingInstance() {
  return {
    close() {},
    setText() {},
    removeElLoadingChild() {},
  }
}
